"use strict";

var _Object$defineProperty = require("babel-runtime/core-js/object/define-property")["default"];

exports["default"] = function (obj, key, value) {
  return _Object$defineProperty(obj, key, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: true
  });
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/babel-runtime/helpers/define-property.js
 ** module id = 181
 ** module chunks = 0
 **/